import { TreeItem } from '@graftcode/design-system'

import { ConstructorData, MethodData } from '@/core/types/library.type'
import { createTreeBadgeContent } from '@/core/utils/createTreeBadgeContent'

import { getEnumKeyName } from '../getEnumKeyName'

const BADGE_LABEL_MAP: Record<string, string> = {
  CONSTRUCTOR: 'Constructor',
  OVERLOADED_CONSTRUCTOR: 'Constructor',
  INSTANCE_METHOD: 'Instance Method',
  OVERLOADED_INSTANCE_METHOD: 'Instance Method',
  STATIC_METHOD: 'Static Method',
  OVERLOADED_STATIC_METHOD: 'Static Method',
  GLOBAL_METHOD: 'Global Method',
  OVERLOADED_GLOBAL_METHOD: 'Global Method',
}

const getBadgeLabel = (type: string | number): string | undefined => BADGE_LABEL_MAP[getEnumKeyName(type)]

/**
 * Maps MethodData or ConstructorData to a TreeItem: id, label, url hash, and optional badge (e.g. "Instance Method", "Constructor").
 *
 * @param itemKey - Optional key for overloaded constructors to ensure unique IDs
 */
export const mapClassItemToTreeItem = (
  item: MethodData | ConstructorData,
  parentPath: string,
  itemKey?: string
): TreeItem => {
  const uniqueId = itemKey || item.name
  const id = `${parentPath}/${uniqueId}`
  const badge = getBadgeLabel(item.type)

  const treeItem: TreeItem = {
    id,
    label: item.name,
    url: `#${id}`,
  }

  if (badge) {
    treeItem.badge = createTreeBadgeContent(badge) as unknown as TreeItem['badge']
  }

  return treeItem
}
